declare var moment: any;

const sos = moment;

sos.defaultFormat = 'YYYY-MM-DD HH:mm:ss';
sos.defaultFormatUtc = 'YYYY-MM-DD HH:mm:ss';

export const sosMoment = sos;
export type Moment = any;
